import { Component, Input } from '@angular/core';

@Component({
	selector: 'cass-indeterminate-horizontal-progress-indicator',
	templateUrl: './indeterminate-horizontal-progress-indicator.component.html',
	styleUrls: ['./indeterminate-horizontal-progress-indicator.component.css']
})
export class IndeterminateHorizontalProgressIndicatorComponent {

	@Input()
	displayString?: string;

	constructor() { }
}
